<template>
    <v-container>
        <FormularioCadastroUnidadesNegocio :unidade-edicao="unidade_para_editar" @resetEdicao="limpaUnidadeEdicao" @registroInserido="registroInserido" />
        <ListagemUnidadesNegocio @editar="editarUnidade" :atualiza-listagem="atualiza_listagem" />
    </v-container>
</template>
<script>
  import FormularioCadastroUnidadesNegocio from '../../../components/cadastros/unidade-negocio/FormularioCadastroUnidadesNegocio.vue'
  import ListagemUnidadesNegocio from '../../../components/cadastros/unidade-negocio/ListagemUnidadesNegocio.vue'
  export default {
    name: 'UnidadesNegocio',
    components: { FormularioCadastroUnidadesNegocio, ListagemUnidadesNegocio },
    data () {
      return {
        unidade_para_editar: null,
        atualiza_listagem: false
      }
    },
    methods: {
      limpaUnidadeEdicao () {
        this.unidade_para_editar = null
      },
      editarUnidade (item) {
        this.unidade_para_editar = item
      },
      registroInserido () {
        this.atualiza_listagem = !this.atualiza_listagem
      }
    }
  }
</script>
